function handleAddFreeGift (triggers, items) {
  let buyItems = items.filter((item) => item.variant_id == triggers.trigger && item.final_line_price > 0);
  console.log('buyItems', buyItems);
  let freeItems = items.filter((item) => item.variant_id == triggers.free && item.final_line_price == 0);
  console.log('freeItems', freeItems);
  //calculate the qty of buyIteme
  const qtyBuy = buyItems.reduce((accumulator, currentValue) => accumulator + currentValue.quantity, 0);

  if (qtyBuy === 1 && freeItems.length === 0) {
      fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        items: [{
          id: triggers.free,
          quantity: 1
        }]
      })
    })
    .then(res => res.json())
    .then(data => {
        document.dispatchEvent(new CustomEvent('cart:build'));
    })
    .catch(err => console.error("Error adding free gift:", err));
  }
}
function handleRemoveFreeGift (triggers, items) {
  console.log('triggers', triggers, items);
  if (items.length > 0) {
    // check if trigger has qty
    let buyItems = items.filter((item) => item.variant_id == triggers.trigger && item.final_line_price > 0);
    console.log('buyItems', buyItems);
    //calculate the qty of buyIteme
    const qtyBuy = buyItems.reduce((accumulator, currentValue) => accumulator + currentValue.quantity, 0);

    let freeItem = items.find((item) => item.variant_id == triggers.free && item.final_line_price == 0);
    console.log('freeItem', freeItem);

     if (qtyBuy === 0 && freeItem) {
          fetch(`/cart/change.js`, {
           method: 'POST',
           headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: freeItem.key,
              quantity: 0
            })
           })
          .then(res => res.json())
          .then(data => {
            document.dispatchEvent(new CustomEvent('cart:build'));
          })
        .catch(err => console.error("Error adding free gift:", err));
      } else if (qtyBuy === 1 && !freeItem && buyItems) {
          fetch(`/cart/change.js`, {
           method: 'POST',
           headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: buyItems[0].key,
              quantity: 0
            })
           })
          .then(res => res.json())
          .then(data => {
            document.dispatchEvent(new CustomEvent('cart:build'));
          })
        .catch(err => console.error("Error adding free gift:", err));
      }
  }
}
function freeGiftFetch(added_variant_id = null, deleted_variant_id = null) {

  let themeSettingsVariants = theme.settings.freeGiftSettings;
  if (themeSettingsVariants !== "") {
    let settingsVariants = [];
    themeSettingsVariants?.split(',').map((fv) => {
      let vArray = fv.split(':');
      if (vArray.length === 2) {
        settingsVariants.push({
          trigger: vArray[0],
          free: vArray[1]
        })
      }
    })
    console.log('settingsVariants', settingsVariants);
    let sVA = (added_variant_id) ? settingsVariants.find((v) => v.trigger == added_variant_id) : null;
    let sVD = (deleted_variant_id) ? settingsVariants.find((v) => v.trigger == deleted_variant_id || v.free == deleted_variant_id) : null;
    console.log('sVA', sVA);
    console.log('sVD', sVD);
    // console.log('function is calling....', trigger_variant, auto_trigger_variant);
    fetch("/cart.json")
      .then((res) => res.json())
      .then((cart) => {
        let items =  cart.items || [];
        if (sVA) {
          handleAddFreeGift(sVA, items)
        }

        if (sVD) {
          handleRemoveFreeGift(sVD, items)
        }

        
      });
  }
}


document.addEventListener('ajaxProduct:added', function(evt) {
  console.log(evt,'ajaxProduct:added');
  freeGiftFetch(evt.detail.product.id, null);
});
document.addEventListener('cart:updated', function(evt) {
  console.log(evt,'cart update');
  let addedVariant = null;
  let deletedVariant = null;
  if (evt.detail.cart.items_added.length > 0) {
    addedVariant = evt.detail.cart.items_added[0].variant_id;
  }
  if (evt.detail.cart.items_removed.length > 0) {
    deletedVariant = evt.detail.cart.items_removed[0].variant_id;
  }
  freeGiftFetch(addedVariant, deletedVariant);
});
$(document).on('click','.cart__remove a',function(e){
  const delete_vartiant = e.target.getAttribute('data-variant');
  console.log('e', e, delete_vartiant)
  setTimeout(function(){
   freeGiftFetch(null, delete_vartiant);
  },500)
});

//freeGiftFetch();
console.log('theme.settings', theme.settings)